/*
 * Default zoning (heatmap) creation payload template for the Demo Environment
 * Management page's "Create payload" editor (entity type: zonings). Mirrors
 * sales-demo-env-setup's `src/heatmaps/create-heatmap.js`'s `resolveConfig`.
 */

export const DESKTOP = 1;
export const TABLET = 2;
export const MOBILE = 3;

const DEFAULT_USER_AGENT =
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/150.0.0.0 Safari/537.36';

function defaultZoningName() {
  const label = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  return `New zoning ${label}`;
}

function defaultDateRange(days = 30) {
  const now = new Date();
  const to = new Date(now);
  to.setUTCHours(23, 59, 59, 999);
  const from = new Date(now);
  from.setUTCDate(from.getUTCDate() - (days - 1));
  from.setUTCHours(0, 0, 0, 0);
  return { from: from.toISOString(), to: to.toISOString() };
}

/**
 * Default create-zoning config, mirroring `src/heatmaps/create-heatmap.js`'s `resolveConfig`.
 * `pageId` must be resolved separately (see `resolvePage`/`resolvePageByUrl` in csqMappings.js)
 * and merged into the returned object before calling `createZoning`.
 */
export function defaultZoningConfig(overrides = {}) {
  const { from, to } = overrides.from && overrides.to ? overrides : defaultDateRange(overrides.days || 30);
  return {
    pageId: overrides.pageId,
    name: overrides.name || defaultZoningName(),
    device: Number(overrides.device || DESKTOP),
    width: Number(overrides.width || 1568),
    height: Number(overrides.height || 886),
    userAgent: overrides.userAgent || DEFAULT_USER_AGENT,
    from,
    to,
    count: Number(overrides.count || 5),
    segmentId: Number(overrides.segmentId ?? -1),
    pollAttempts: Number(overrides.pollAttempts || 20),
    pollDelayMs: Number(overrides.pollDelayMs || 3000),
  };
}

/**
 * Builds the segment tree used to scope the screenshot suggestions.
 * `segmentId: -1` means "all users".
 */
export function buildSegment(segmentId) {
  return {
    children: [{ nodeType: 'filter', field: 'segment:id', operator: 'equals', value: segmentId }],
    nodeType: 'AND',
  };
}
